module.exports = __webpack_public_path__ + "static/img/10.e9f1481.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/10.png
// module id = j1Kl
// module chunks = 0